export const AuthParams = {
	authCode: "code",
	authLogin: "login",
	authPath: "path",
	authUserState: "userState",
};

export const AuthUserState = {
	Authenticated: "Authenticated",
};
